import React, { FC } from 'react';
import PopupNg from '@/ui/PopupNg';
import StatsDialog from '@/common/components/statsDialog/StatsDialog';
import { SvgIcon } from 'nike-ui/src/icons/SvgIcon';
import clsx from 'clsx';
import { registerPopup } from '@/ui/popupRegistrar';
import { DialogBody, Docked } from '@/ui/dialogs/Dialog';

const DIALOG_NAME = 'dialog/match/stats';

registerPopup(DIALOG_NAME, popup => <MatchStatsDialog {...popup.get('data')} />);

const MatchStatsDialog = ({ body, close, dialogClass, bodyClass }) => (
    <Docked className={dialogClass}>
        <DialogBody className={bodyClass}>{React.cloneElement(body, { close })}</DialogBody>
    </Docked>
);

const StatsIcon: FC<{ statsId?; btnClass?; iconClass?; size?: string; isTournament?; usePlaceholder?: boolean }> = ({
    statsId,
    btnClass,
    iconClass = 'c-black-50',
    size = '16',
    isTournament,
    usePlaceholder
}) => {
    const onclick = e => {
        e.preventDefault();
        e.stopPropagation();
        const close = () => {
            PopupNg.dispatcher.close(DIALOG_NAME);
        };
        PopupNg.dispatcher.open(DIALOG_NAME, {
            body: <StatsDialog statisticsId={statsId} isTournament={isTournament} />,
            dialogClass: 'theme-dark',
            bodyClass: 'p-0',
            close
        });
    };
    return statsId ? (
        <button onClick={onclick} className={clsx(btnClass)}>
            <SvgIcon imgId="live-stats" sizeX={size} sizeY={size} className={clsx(iconClass)} />
        </button>
    ) : usePlaceholder ? (
        <div className="px-2 mx-20 py-10" />
    ) : null;
};

export default StatsIcon;
